import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Form } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useDispatch, useSelector } from 'react-redux';
import IABILET_LOGO from '../../assets/img/iabilet-blue.svg';
import { doCheckUserByEmail, doSocialConnect, setEmailUser } from '../../actions/auth';
import { CONNECT_IABILET } from '../../../sell/api/config';
import { localeSelector } from '../../selectors/i18n';

const LoginContentStep1 = ({ auth, targetPath }) => {
    const locale = useSelector(localeSelector);
    const dispatch = useDispatch();
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(doCheckUserByEmail(auth.email));
    };
    const showLoginWithEmail = () => {
        document.getElementById('connect-email-container').style.display = 'block';
        document.getElementById('connect-email__action').style.display = 'none';
    };
    return (
        <div>
            <div className="connect__btns d-grid gap-2 mb-4">
                <Button variant="outline-dark" size="lg"
                    onClick={() => doSocialConnect(CONNECT_IABILET, targetPath)}>
                    <FormattedMessage id="connect_with"/>
                    <img src={IABILET_LOGO} alt="IaBilet" className="logo-iabilet img-fluid ms-2"/>
                </Button>
            </div>
            <div id="connect-email__action"
                className="mt-3 justify-content-center text-center"><FormattedMessage id="login_already_have_account"/>
                <span className="link-primary ms-2" id="login-email"
                    onClick={showLoginWithEmail}>
                    <FormattedMessage id="sing_in"/>
                </span>
            </div>
            <div id="connect-email-container" style={{ display: 'none' }}>
                <p id="connect-email-container" className="text-muted text-center mb-4">
                    <FormattedMessage id="login_modal_alternative"/>
                </p>
                <Form onSubmit={handleSubmit}>
                    <FloatingLabel
                        controlId="login-email"
                        label={<FormattedMessage id="login_modal_email_placeholder"/>}
                        value={auth.email}
                        onChange={(e) => dispatch(setEmailUser(e.target.value))}
                        className="mb-3">
                        <Form.Control size="lg" label={<FormattedMessage id="login_modal_email_placeholder"/>}
                            type="email" required="required"
                            placeholder={<FormattedMessage id="login_modal_email_placeholder"/>}/>
                    </FloatingLabel>
                    <div className="d-grid mb-4">
                        <Button variant="primary" type="submit">
                            <FormattedMessage id="login_modal_email_btn_text"/>
                        </Button>
                    </div>
                </Form>
                <p className="text-center"><FormattedMessage id="login_modal_footer_continue"/> <a href={`/${locale}/show/termeni-si-conditii`} target="_blank" rel="noreferrer"><FormattedMessage
                    id="login_modal_footer_terms"/></a> <FormattedMessage id="login_modal_footer_ours"/></p>
            </div>
        </div>
    );
};
export default LoginContentStep1;
